import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import moment from 'moment';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CascadeSelectModule } from 'primeng/cascadeselect';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectButtonModule } from 'primeng/selectbutton';
import { StepsModule } from 'primeng/steps';
import { TabMenuModule } from 'primeng/tabmenu';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import uuid4 from "uuid4";
import { Application } from '../../../../model/Application';
import { Course } from '../../../../model/Course';
import { HttpResponse } from '../../../../model/HttpResponse';
import { Level } from '../../../../model/Level';
import { ProcessStatus } from '../../../../model/ProcessStage';
import { AcademyAdministratorOperation } from '../../../../model/administrator/AcademyAdministratorOperation';
import { AcademyAdministratorType } from '../../../../model/administrator/AcademyAdministratorType';
import { AdministratorEntity } from '../../../../model/administrator/AdministratorEntity';
import { Discount } from '../../../../model/administrator/AgreementsAndDiscounts/Discount';
import { Product } from '../../../../model/administrator/ProductAndServices/Product';
import { Documento } from '../../../../model/documento';
import { ApplicationType } from '../../../../model/enum/ApplicationType';
import { LegacyMember } from '../../../../model/legacy/LegacyMember';
import { PaymentResponseStatus } from '../../../../model/payment/PaymentReponseStatus';
import { AdministrationService } from '../../../../services/administration.service';
import { ApplicationService } from '../../../../services/application.service';
import { DocumentsService } from '../../../../services/documents.service';
import { GestionService } from '../../../../services/gestion.service';
import { LoadingService } from '../../../../services/loading.service';
@Component({
  selector: 'app-solicitud-review',
  standalone: true,
  imports: [
    ConfirmDialogModule,
    DropdownModule,
    StepsModule,
    TabMenuModule,
    CommonModule,
    CardModule,
    ButtonModule,
    TabViewModule,
    DialogModule,
    SelectButtonModule,
    FormsModule,
    CascadeSelectModule,
    ToastModule,
    InputTextareaModule,
    TagModule,
    MultiSelectModule,
    DropdownModule
    
  ],
  providers: [ConfirmationService, MessageService],
  templateUrl: './solicitud-review.component.html',
  styleUrl: './solicitud-review.component.scss',
})
export class SolicitudReviewComponent implements OnInit {
  activeIndex: number = 0;
  documentPreviewSelected: any = null;
  showDocumentPreview: boolean = false;
  @Input()
  application!: Application;

  @Output()
  goToBackEvent: EventEmitter<boolean> = new EventEmitter();

  stateOptions: any[] = [
    { label: 'Aprobar Solicitud', value: ProcessStatus.ACCEPTED_PAYMENT_PENDING },
    { label: 'Rechazar Solicitud', value: ProcessStatus.REJECTED },
  ];
  confirmationResponse: ProcessStatus = ProcessStatus.ACCEPTED_PAYMENT_PENDING;
  
  applicationTypeOptions: any[] = [
    { label: 'Nueva Vinculación', value: ApplicationType.NEW },
    { label: 'Renovación', value: ApplicationType.RENEWAL },
    { label: 'Transferencia', value: ApplicationType.TRANSFER }
  ];
  selectedApplicationType: ApplicationType = ApplicationType.NEW;
  nivelAsignado?: Level;
  productosAsignados: Product[] = [];
  descuentos:Discount[] = [];
  courses: Course[] = [];
  levels: Level[] = [];
  rejectComments:string = '';
  productos:Product[] = [];
  legacyData:LegacyMember[] = [];
  showLegacyMemberInfo:boolean = false;
  constructor(
    private documentsService: DocumentsService,
    private sanitizer: DomSanitizer,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private loadingService: LoadingService,
    private applicationService: ApplicationService,
    private administrationService:AdministrationService,
    private gestionService:GestionService
  ) {}

  ngOnInit(): void {
    this.buildMasterOptions();
    this.getLegacyMemberInfo();
    this.initializeApplicationType();
  }

   async getLegacyMemberInfo() {
    const legacyData =  await this.getEntityGestion(AcademyAdministratorType.LEGACY_MEMBERS,this.application.applicant.idNumber,'identificacion');
    if(legacyData){
      this.legacyData = legacyData;
    }
  }

  initializeApplicationType() {
    if (this.legacyData && this.legacyData.length > 0) {
      this.selectedApplicationType = ApplicationType.RENEWAL;
    } else {
      this.selectedApplicationType = ApplicationType.NEW;
    }
  }

  calculateYearsOld(birthDay: string) {
    return moment().diff(birthDay, 'years');
  }

  showPreview(documento: Documento) {
    this.loadingService.showLoading();
    this.documentsService
      .getDocument(documento.documentId)
      .subscribe((res: HttpResponse) => {
        this.loadingService.hideLoading();
        this.documentPreviewSelected = {
          documentName:
            documento.id === 'docId'
              ? 'Documento de Identificación'
              : documento.id === 'docEps'
              ? 'Certificado de Eps'
              : documento.id === 'docDiscalimer'
              ? 'Consentimiento Informado'
              : documento.id,
          base64: this.sanitizer.bypassSecurityTrustResourceUrl(
            res.response.filestream
          ),
        };
        this.showDocumentPreview = true;
      });
  }

  
  async buildMasterOptions() {
    //this.courses = await this.getCourses();
    this.productos = await this.getProducts();
  }

  async getCourses(): Promise<Course[]> {
    const groupData = await this.getEntity(
      AcademyAdministratorType.COURSES_LEVELS,
      true,
      'isActive'
    );
    return groupData as Course[];
  }

  async getProducts(): Promise<Product[]> {
    const groupData = await this.getEntity(
      AcademyAdministratorType.PRODUCTS_SERVICES,
      true,
      'isActive'
    );
    return groupData as Product[];
  }


  async getEntity(
    academyAdministratorType: AcademyAdministratorType,
    value: any,
    property?: string
  ): Promise<any[]> {
    return new Promise<any[]>((resolve, reject) => {
      this.loadingService.showLoading();

      let data: any[] = [];
      let entity: AdministratorEntity = {
        operation: AcademyAdministratorOperation.SELECT,
        payload: {
          options: {
            conditionals: [
              {
                conditionalConnector: null,
                logicOperator: '=',
                evaluatedProperty: property || 'id',
                parameterName: '@Option1',
                parameterValue: value,
              },
            ],
          },
        },
        type: academyAdministratorType,
      };
      try {
        this.administrationService
          .sendRequest(entity)
          .subscribe((res: HttpResponse) => {
            if (res.response.length > 0) {
              data = res.response as any[];
            }
            resolve(data);
            this.loadingService.hideLoading();
          });
      } catch (error) {
        reject(error);
      }
    });
  }


  async getEntityGestion(
    academyAdministratorType: AcademyAdministratorType,
    value: any,
    property?: string
  ): Promise<any[]> {
    return new Promise<any[]>((resolve, reject) => {
    
      let data: any[] = [];
      let entity: AdministratorEntity = {
        operation: AcademyAdministratorOperation.SELECT,
        payload: {
          options: {
            conditionals: [
              {
                conditionalConnector: null,
                logicOperator: '=',
                evaluatedProperty: property || 'id',
                parameterName: '@Option1',
                parameterValue: value,
              },
            ],
          },
        },
        type: academyAdministratorType,
      };
      try {
        this.gestionService
          .sendRequest(entity)
          .subscribe((res: HttpResponse) => {
            if (res.response.length > 0) {
              data = res.response as any[];
            }
            resolve(data);
         
          });
      } catch (error) {
        reject(error);
      }
    });
  }




  sendResponse(event: Event) {
    if (!this.confirmationResponse) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atención',
        detail: 'Debe completar todos los campos requeridos para continuar',
      });
    } else if (this.confirmationResponse === ProcessStatus.ACCEPTED_PAYMENT_PENDING && (!this.selectedApplicationType || this.productosAsignados.length === 0)) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atención',
        detail: 'Debe seleccionar el tipo de solicitud y al menos un producto o servicio para continuar',
      });
    } else {
      this.confirmationService.confirm({
        target: event.target as EventTarget,
        message: `Esta seguro de enviar la respuesta de la solicitud con estado ${
          this.confirmationResponse === ProcessStatus.ACCEPTED_PAYMENT_PENDING
            ? 'Aprobada'
            : this.confirmationResponse === ProcessStatus.REJECTED
            ? 'Rechazada'
            : this.confirmationResponse
        }`,
        header: 'Confirmar envío de respuesta',
        icon: 'pi pi-exclamation-triangle',
        acceptIcon: 'none',
        rejectIcon: 'none',
        acceptLabel: 'Si',
        rejectLabel:'No',
        rejectButtonStyleClass: 'p-button-text',
        accept: () => {
          if (this.application && this.application.process) {
            this.application.process.processStage = this.confirmationResponse;
            this.application.type = this.selectedApplicationType; 

            if( this.confirmationResponse === ProcessStatus.ACCEPTED_PAYMENT_PENDING){
              this.application.payment = {
                paymentItems:this.productosAsignados.map((product:Product) => {
                  return {
                    amount:product.price,
                    product:product.name,
                    descripcion:product.description,
                    tipo:product.type,
                    valorUnitario:product.price,
                    valorTotal:product.hasTax ? product.price + (product.price * product.taxValue) : product.price,
                    porcentajeIva:product.taxValue,
                  }
  
                }),
                paymentId:uuid4(),
                paymentStatus:PaymentResponseStatus.PENDING,
                paymentDate:''
              }
            }else if(this.confirmationResponse === ProcessStatus.REJECTED){
              this.application.comments = this.rejectComments
            }
          }
          this.loadingService.showLoading();
          this.applicationService
          .updateApplication(this.application)
          .subscribe((updateResponse: HttpResponse) => {
            if (updateResponse.response) {
              this.messageService.add({
                severity: 'success',
                summary: 'Envío Exitoso!',
                detail: 'La solicitud se respondió correctamente',
              });
              this.loadingService.hideLoading();
              this.goToBack();
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error!',
                detail:
                  'Ocurrió un error actualizando el estado de la solicitud, por favor inténtelo nuevamente',
                life: 3000,
              });
            }
          });
        },
        reject: () => {
          this.messageService.add({
            severity: 'warning',
            summary: 'Sin Cambios',
            detail: 'No se realizaron cambios en la solicitud',
            life: 3000,
          });
        },
      });
    }
  }

  goToBack() {
    this.goToBackEvent.emit(true);
  }

  showLegacyInfo(){
    this.showLegacyMemberInfo = true;
  }

  shouldShowPaymentTab(): boolean {
    return this.application?.process?.processStage !== 'created' && 
           this.application?.process?.processStage !== 'rejected';
  }

  getTotalPayment(): number {
    if (!this.application?.payment?.paymentItems) {
      return 0;
    }
    return this.application.payment.paymentItems.reduce((total, item) => total + item.valorTotal, 0);
  }

  getPaymentStatusLabel(status: string): string {
    switch (status) {
      case 'created':
        return 'PENDIENTE REVISIÓN';
      case 'approved':
        return 'APROBADA';
      case 'responsed':
        return 'RESPUESTA ENVIADA';
      case 'responsed_rejected':
        return 'RESPUESTA RECHAZADA ENVIADA';
      case 'responsed_approved':
        return 'RESPUESTA APROBADA ENVIADA';
      case 'rejected':
        return 'RECHAZADA';
      case 'finished':
        return 'FINALIZADA';
      case 'payment_started':
        return 'En proceso de pago';
      case 'finished_approved':
        return 'Pagado';
      case 'finished_declined':
        return 'Finalizado pago rechazado';
      case 'finished_error':
        return 'Finalizado error de pago';
      case 'finished_payment_rejected':
        return 'Finalizado pago rechazado';
      case 'accepted_payment_pending':
        return 'Aprobado - Pendiente de Pago';
      case 'finished_payment_error':
        return 'Error en Pago';
      case 'payment_manual_validation':
        return 'Pago en Revisión Manual';
      case 'payment_abandoned':
        return 'Pago Abandonado';

      default:
        return 'Estado Desconocido';
    }
  
  }

  getPaymentStatusSeverity(status: string): 'success' | 'info' | 'warning' | 'danger' {
    switch (status) {
      case 'created':
      case 'approved':
      case 'responsed':
      case 'responsed_approved':
      case 'finished':
      case 'finished_approved':
        return 'success';
      case 'rejected':
      case 'finished_declined':
      case 'finished_error':
      case 'finished_payment_rejected':
        return 'danger';
      case 'payment_started':
      case 'accepted_payment_pending':
      case 'payment_manual_validation':
      case 'payment_abandoned':
        return 'warning';
      default:
        return 'info';
    }
  }

  getApplicationTypeDisplay(): { label: string; isSuggestion: boolean; severity: 'success' | 'info' | 'warning' | 'danger' } {
    if (this.application?.type) {
      // Si ya tiene un tipo definido, mostrar ese tipo
      const typeLabel = this.getApplicationTypeLabel(this.application.type);
      const severity = this.getApplicationTypeSeverity(this.application.type);
      return {
        label: typeLabel,
        isSuggestion: false,
        severity: severity
      };
    } else {
      // Si no tiene tipo definido, sugerir basado en legacy data
      const isRenewal = this.legacyData && this.legacyData.length > 0;
      const suggestedType = isRenewal 
        ? 'Renovación (Sugerido)' 
        : 'Nueva Vinculación (Sugerido)';
      const severity = isRenewal ? 'warning' : 'info';
      return {
        label: suggestedType,
        isSuggestion: true,
        severity: severity
      };
    }
  }

  private getApplicationTypeSeverity(type: ApplicationType): 'success' | 'info' | 'warning' | 'danger' {
    switch (type) {
      case ApplicationType.NEW:
        return 'success';        // Azul para nueva vinculación
      case ApplicationType.RENEWAL:
        return 'info';     // Naranja para renovación
      case ApplicationType.TRANSFER:
        return 'warning';      // Rojo para transferencia
      default:
        return 'danger';
    }
  }

  private getApplicationTypeLabel(type: ApplicationType): string {
    switch (type) {
      case ApplicationType.NEW:
        return 'Nueva Vinculación';
      case ApplicationType.RENEWAL:
        return 'Renovación';
      case ApplicationType.TRANSFER:
        return 'Transferencia';
      default:
        return 'Tipo Desconocido';
    }
  }

  getApplicationTypeForHeader(): string {
    const typeDisplay = this.getApplicationTypeDisplay();
    return typeDisplay.label;
  }
}
